module.exports = __webpack_public_path__ + "img/presentation11.631ed0b7.jpg";